import { inject, provideAppInitializer } from '@angular/core';

import { GrowthBookService, UiStore } from '@pt/services';

import { registerAnalyticsFactory, registerLocaleFactory } from './factories';

/**
 * Core app initializers
 */
export const CORE_APP_INITIALIZERS = [
  provideAppInitializer(() => {
    return inject(UiStore).init();
  }),
  provideAppInitializer(() => {
    return inject(GrowthBookService).init();
  }),
  provideAppInitializer(() => {
    const initializerFn = (registerLocaleFactory)();
    return initializerFn();
  }),
  provideAppInitializer(() => {
    const initializerFn = (registerAnalyticsFactory)();
    return initializerFn();
  }),
];
